/** @jsxImportSource @emotion/react */
import { Route, Routes } from 'react-router-dom';
import {
  TransactionRequestDetails,
  TransactionRequestOverview,
} from './components';

export const TransactionRequests = () => {
  return (
    <Routes>
      <Route path="/" element={<TransactionRequestOverview />} />
      <Route path="/:referenceId" element={<TransactionRequestDetails />} />
    </Routes>
  );
};
